import SignaturePad from "signature_pad";
import GLightbox from "glightbox";

import Keselect from "keselect";
import "keselect/dist/keselect.min.css";

const flatpickr = require("flatpickr");
const German = require("flatpickr/dist/l10n/de.js").default.de;
require("flatpickr/dist/themes/light.css");

flatpickr.localize(German);

import TripParticipantsTable from "./TripParticipantsTable";


document.addEventListener("DOMContentLoaded", function (event) {
    const datefilters = document.querySelectorAll('[data-behaviour="date-filter"]');

    [...datefilters].forEach(node => {
        node.addEventListener('change', (e) => {
            node.form.submit();
        });
    });

    /*
     * Date fields
     */

    const datefields = document.querySelectorAll('input[type="date"]');

    [...datefields].forEach(node => {
        if(node.name === "DoB")
            return;
        flatpickr(node, {
            altFormat: "d.m.Y",
            altInput: true,
            maxDate: node.dataset.type == "tripDate" ? new Date() : null
            // minDate: new Date(),
        });
    });

    const replacedFields = document.querySelectorAll('[class=" form-control input"]');

    [...replacedFields].forEach(node => {
        node.dataset.type = "date";
    })

    /*
     * Time fields
     */

    const timefields = document.querySelectorAll('input[type="time"]');

    [...timefields].forEach(node => {
        flatpickr(node, {
            enableTime: true,
            noCalendar: true,
            dateFormat: "H:i",
            time_24hr: true,
            minTime: "09:00",
            maxTime: "17:00",
        });
    })

    /*
     * Signature fields
     */

    const signatureFields = document.querySelectorAll('[data-behaviour="signature"]');

    [...signatureFields].forEach(node => {
        const canvas = node.querySelector('[data-behaviour="signature-canvas"]')
        const signaturePad = new SignaturePad(canvas);
        const field = document.querySelector('[data-behaviour="signature-field"]') //Only one.
        if(field.value)
            signaturePad.fromDataURL(field.value);
        canvas.addEventListener("mouseup", (e) => {
            field.value = signaturePad.toDataURL("image/svg+xml");
        })
        canvas.addEventListener("touchend", (e) =>  {
            field.value = signaturePad.toDataURL("image/svg+xml");
        })
    });

    const signatureClear = document.querySelectorAll('[data-behaviour="signature-clear"]');

    [...signatureClear].forEach(element => {
        element.addEventListener("click", (e) => {
            const canvas = document.querySelector('[data-behaviour="signature-canvas"]')
            const signaturePad = new SignaturePad(canvas);
            signaturePad.clear();
            const field = document.querySelector('[data-behaviour="signature-field"]') //Only one.
            field.value = '';
        })
    });

    /*
     * Table details
     */

    const tableToggles = document.querySelectorAll('[data-behaviour="toggle-table-details"]');

    [...tableToggles].forEach(node => {
        node.addEventListener("click", () => {
            const row = node.parentNode.parentNode;
            const nextRow = row.parentNode.rows[row.rowIndex + 1];
            nextRow.classList.toggle("hiddenrow--show");
        })
    });

    /*
     * Select fields with autocomplete
     */

    const selects = document.querySelectorAll('[data-behaviour="fallback"]');

    selects.forEach(select => {
        select.style.visibility = "hidden";
        new Keselect(select);
    });

    /*
     * Rentals: Item forms
     */

    const itemForm = document.querySelector('[data-behaviour="item-form"]');
    if(itemForm) {
        const fields = itemForm.querySelectorAll('input');
        const priceDisplay = itemForm.querySelector('[data-behaviour="price"]')
        const url = itemForm.getAttribute('action');

        const updatePrice = () => {
            const data = new FormData(itemForm);
            data.set('action_updateItem', '1');
            fetch(url, {
                method: 'post',
                body: data,
            }).then(response => response.text())
                .then(result => {
                    priceDisplay.innerHTML=result;
                    }
                );
        }


        fields.forEach(field => {
            field.addEventListener("change", (e) => {
                updatePrice();
            })
            field.addEventListener("keyup", (e) => {
                updatePrice();
            })
        })
    }

    /*
     * Rental page: Notes
     */

    const item_notes = document.querySelectorAll('[data-behaviour="showhide-note"]');

    item_notes.forEach(note => {
        const h3 = note.querySelector("h3")
        h3.addEventListener("click", () => {
            h3.parentNode.classList.toggle("item_content_note--visible");
        })
    });

    const lightboxes = GLightbox({
        selector: '.lightbox',
        touchNavigation: true,
        loop: true,
    });

    /*
     * Rentals: Sperren
     */

    const confirmActions = document.querySelectorAll('[data-behaviour="confirmAction"]');

    [...confirmActions].forEach(node => {
        node.onclick = (e) => {
            let text = "";
            if(node.dataset.type == "lock") {
                text = "Bist du sicher, dass du dieses Objekt für den gewählten Zeitraum sperren möchtest?";
            }
            else if(node.dataset.type == "delete") {
                text = "Bist du sicher, dass du die ausgewählte Buchung löschen möchtest?";
            }
            let result = window.confirm(text);
            if(result) {
                window.open(node.dataset.url, "_self")
            }
        };
    });

    /*
    * Trips: Other Benefits
    */
    const otherBenefits = document.querySelector('[data-behavior="otherBenefits"]');
    if(otherBenefits) {
        otherBenefits.addEventListener("change", (e) => {
            if (e.currentTarget.checked) {
                alert("ACHTUNG! Wenn dieses Kästchen angekreuzt ist, erhalten Sie keine Kreisförderung");
            }
        });
    }

    /*
     * Trips: Day selection
     */

    const daysResult = document.querySelector('[data-behavior="daysResult"]');
    const daysDisplay = document.querySelector('[data-behavior="daysDisplay"]');
    if(daysResult) {
        let fromField = document.querySelector('[data-behavior="daysFrom"]');
        let toField = document.querySelector('[data-behavior="daysTo"]');

        fromField.addEventListener("change", (e) => dayCount());
        toField.addEventListener("change", (e) => dayCount());

        function dayCount() {
            let from = new Date(fromField.value);
            let to = new Date(toField.value);
            let diffTime = Math.abs(to - from);
            let days = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1; // Count the day of departure
            daysResult.value = days;
            let daysText = days ? `${days}` : '';
            if(days < 3) {
                daysText += ' <br/><strong>Hinweis: Es werden nur Fahrten mit mindestens drei Tagen Aufenthalt gefördert. Abweichende Regelung gültig bis 01.05.22: \n' +
                    'Auch Tagesveranstaltungen mit mind. 6 Std. förderungswürdig.</strong>';
            }
            if(days > 21) {
                days = 21;
                daysText = `${days}`;
                daysText += ' <br/><strong>Hinweis: Es werden maximal 21 Tage gefördert.</strong>';
            }
            daysDisplay.innerHTML = daysText;
        }

        dayCount();
    }

    /*
     * Trips: Other Qualification
     */

    const qualificationField = document.getElementById('Form_PersonalDataForm_OtherQualification_1');
    if(qualificationField) {
        const updateQualification = () => {
            const other = qualificationField.checked;
            if(other) {
                document.getElementById('juleica-details').style.display = 'none';
                document.getElementById('other-details').style.display = 'block';
            } else {
                document.getElementById('juleica-details').style.display = 'block';
                document.getElementById('other-details').style.display = 'none';
            }
        }
        qualificationField.addEventListener('change', updateQualification);
        document.getElementById('Form_PersonalDataForm_OtherQualification_0').addEventListener('change', updateQualification);
        updateQualification();
    }

    /*
     * Trips: Participants table
     */

    const participantField = document.querySelector('[name=Participants]')
    if(participantField) {
        const participantsValue = participantField.value;

        const config = JSON.parse(document.getElementById('config').innerHTML);

        const participantsData = participantsValue ? JSON.parse(participantsValue) : [
            [""]
        ];

        const table = new TripParticipantsTable(participantsData, participantField, document.getElementById('spreadsheet'), config)

        // Add onsubmit handler
        const form = document.getElementById('Form_ParticipantListForm');
        if(form) {
            form.addEventListener('submit', () => {
                table.submitting = true;
            });
        }
    }

    /*
     * Trips: Upload form
     */

    const uploadForm = document.querySelector('[data-behaviour="single-upload"]');
    if(uploadForm) {
        const button = uploadForm.querySelector('button.button');
        const label = uploadForm.querySelector('label');
        const field = uploadForm.querySelector('input[type="file"]');

        field.addEventListener("change", (event) => {
            if(event.target.value) {
                field.form.submit();
            }
            // const uploadFileName = event.target.value.split('\\').pop();
            // label.innerText = uploadFileName;
            // button.classList.add('button--show');
        })
    }



});
